const API_BASE = (
  process.env.REACT_APP_BACKEND_URL ||
  'https://greatleadersplatformbackend.onrender.com'
).replace(/\/$/, '');

export function apiUrl(path) {
  return `${API_BASE}${path}`;
}

export async function parseJsonResponse(response) {
  const result = await response.json().catch(() => ({}));
  if (!response.ok || result.success === false) {
    throw new Error(result.message || result.error || 'Request failed');
  }
  return result;
}

export async function verifyContactLead(payload) {
  const response = await fetch(apiUrl('/api/leads/contact/verify'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJsonResponse(response);
}

export async function submitContactLead(payload) {
  const response = await fetch(apiUrl('/api/leads/contact'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJsonResponse(response);
}

export async function submitDownloadLead(payload) {
  const response = await fetch(apiUrl('/api/leads/download'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJsonResponse(response);
}
